import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-line/70 bg-panel/60">
      <div className="mx-auto flex max-w-[1500px] flex-col items-start justify-between gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center lg:px-14">
        <div>
          <p className="font-display text-3xl uppercase tracking-wide text-zinc-100">
            His Grace{" "}
            <span className="text-gold">Auto Repair</span>
          </p>
          <p className="mt-2 font-mono text-xs uppercase tracking-[0.22em] text-zinc-300">
            Customer satisfaction is our priority
          </p>
        </div>
        <div className="font-mono text-xs uppercase leading-loose tracking-[0.16em] text-zinc-300">
          <p>580 Jersey Ave, Unit 2 — New Brunswick, NJ 08901</p>
          <a
            href="tel:+17323392277"
            className="transition-colors hover:text-gold"
          >
            732-339-2277
          </a>
          <br />
          <a
            href="mailto:amos.olayemi@yahoo.com"
            className="transition-colors hover:text-gold"
          >
            amos.olayemi@yahoo.com
          </a>
        </div>
        <div className="flex items-center gap-6">
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400 transition-colors hover:text-gold"
          >
            <Shield size={13} /> Admin
          </Link>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">
            © {new Date().getFullYear()} His Grace Auto Repair
          </p>
        </div>
      </div>
    </footer>
  );
}
